module.exports = __webpack_public_path__ + "img/金星.9a5e82f6.svg";